// Shared helpers for the Manual Compose feature.
// Keep this file pure (no imports of components / hooks) — used by both the
// composer editor and the live preview pane.

export const WORDS_PER_MINUTE = 230;

export function countWords(s) {
  if (!s) return 0;
  const t = String(s).trim();
  return t ? t.split(/\s+/).length : 0;
}

export function readTime(words) {
  if (!words) return "0 min";
  const mins = Math.max(1, Math.round(words / WORDS_PER_MINUTE));
  return mins < 60 ? `${mins} min` : `${Math.floor(mins/60)}h ${mins%60}m`;
}

// Split raw textarea content on blank lines into paragraph strings.
export function paragraphs(text) {
  return (text || "").split(/\n{2,}/).map((p) => p.trim()).filter(Boolean);
}
